import { twMerge } from '@sortlist-frontend/design-system';

import type { GuidePageContent } from '../types';
import { RevealOnScroll } from './RevealOnScroll';

interface GuideKeyPointsProps {
  section: GuidePageContent['keyPoints'];
}

export const GuideKeyPoints = (props: GuideKeyPointsProps) => {
  const { section } = props;

  return (
    <section id="key-points" className="scroll-mt-24" aria-labelledby="key-points-title">
      <h2 id="key-points-title" className="text-2xl font-semibold text-secondary-950">
        {section.title}
      </h2>
      <ul className="mt-5 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {section.items.map((item, index) => (
          <RevealOnScroll
            key={item.title}
            as="li"
            className={twMerge(
              'rounded-2xl border p-5',
              index === 0 ? 'border-primary-200 bg-primary-50' : 'border-secondary-200 bg-white',
            )}>
            <p className="text-3xl font-extrabold tracking-tight text-secondary-950">{item.big}</p>
            <p className="mt-2 text-sm font-bold text-secondary-950">{item.title}</p>
            <p className="mt-1 text-sm leading-relaxed text-secondary-700">{item.text}</p>
          </RevealOnScroll>
        ))}
      </ul>
    </section>
  );
};
